import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { Flex } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { LBLinkButton } from '@/shared/ui-kit/components';

export const ChatMessageInput = ({
  sendMessage
}: {
  sendMessage: (message: string) => Promise<void>;
}) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const onSubmit = async () => {
    if (message.trim()) {
      await sendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      await onSubmit();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, [message]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <Flex align='center' gap={10}>
        <div style={{ width: '100%' }}>
          <textarea
            ref={inputRef}
            placeholder='Написать сообщение'
            rows={1}
            value={message}
            style={{
              width: '100%',
              borderRadius: '20px',
              resize: 'none',
              overflow: 'hidden',
              padding: '8px 12px',
              lineHeight: '1.4',
              border: '1px solid #ccc',
              fontSize: '14px'
            }}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <LBLinkButton
          type='submit'
          style={{
            background: 'red',
            color: 'white',
            borderRadius: '24px',
            padding: '7px'
          }}
        >
          <PaperAirplaneIcon width={24} />
        </LBLinkButton>
      </Flex>
    </form>
  );
};
